// ReportingMenu.js
// Reporting menu button for the main navigation

import React from "react";
import styles from "./ReportingMenu.module.css";

export const ReportingMenu = ({
  activeTab,
  mainMenuStyles,
  handleMainMenuButtonClick,
}) => {
  return (
    <button
      className={`${mainMenuStyles.tabButton} ${styles.reportingButton} ${
        activeTab === "reporting" ? styles.active : ""
      }`}
      onClick={() => handleMainMenuButtonClick("reporting")}
      data-testid="reporting-tab"
    >
      Reports
    </button>
  );
};
